// extracted by mini-css-extract-plugin
export default {"container":"admin-sidebar_container__X9Ted"};